import { checkoutWidgetsSchema } from "@redotech/redo-model/checkouts/checkout-widgets-builder";
import { CheckoutOptimizationWidgetType } from "@redotech/redo-model/checkouts/widget";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const createCheckoutWidgetInputSchema_ = z.object({
  widgetType: createEnum(CheckoutOptimizationWidgetType),
  widgetData: checkoutWidgetsSchema,
});

export const createCheckoutWidget = {
  name: "createCheckoutWidget" as const,
  input: createCheckoutWidgetInputSchema_,
  output: zExt.objectId(),
};
